import { getApi, postApi } from "../apiCall";

export const getGetListCurrent = (token, user) => {
  let url = `${process.env.REACT_APP_API_URL}/${user}/capacity/getAll?current=true`;
  return postApi(url);
};

export const getGetListConnectOpen = (token, user, id) => {
  let url = `${process.env.REACT_APP_API_URL}/capacity/landing-cost/matchmaking/${user}?capacityId=${id}`;
  return postApi(url);
};

export const getGetListConnectSelected = (token, user, id, payload) => {
  let url = `${process.env.REACT_APP_API_URL}/capacity/landing-cost/matchmaking/${user}?capacityId=${id}`;
  return postApi(url, payload);
};

export const createConGenListing = ({ token, user, payload }) => {
  let url = `${process.env.REACT_APP_API_URL}/${user}/capacity/create`;
  return postApi(url, payload);
};

export const getAllBidReceived = (token, user, id) => {
  let url = `${process.env.REACT_APP_API_URL}/bidding/${user}/received?capacityId=${id}&isHistory=false`;
  return getApi(url);
};

export const getConnectionDetails = ({
  token,
  user,
  placedAgainst,
  genId,
  conId,
}) => {
  let url = `${process.env.REACT_APP_API_URL}/bidding/${user}/${placedAgainst}?capacityGeneratorId=${genId}&capacityConsumerId=${conId}`;
  return getApi(url);
};

// --------- Document Generation ---------

export const generateLoaDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/loa/WORD/BSB/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};
// export const generateObligationDocument = (repScheduleId) => {
//   const url = `${process.env.REACT_APP_API_URL}/doc/generate/obligation/PDF/BSB/${repScheduleId}`;
//   return postApi(url, {}, {}, false, "blob");
// };

export const generateObligationDocument = (repScheduleId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/obligation/by-bilateral-contract/PDF/BSB/${repScheduleId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const generateFinalDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/agreement/WORD/BSB/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};

export const generateLoiDocument = (connectionId) => {
  const url = `${process.env.REACT_APP_API_URL}/doc/generate/loi/WORD/BSB/${connectionId}`;
  return postApi(url, {}, {}, false, "blob");
};
export const downloadListing = (id, isBilateralSearch) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/generate/listing/PDF/BSB/${id}`;
  if (isBilateralSearch) {
    url += `/${isBilateralSearch}`;
  }
  return postApi(url, {}, {}, false, "blob");
};
